<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="!selectedContract">Selezionare un veicolo</b-card>
        <b-card v-else>
          <div slot="header">
            Percorsi del veicolo:
            <strong>{{ selectedContract.alias }}</strong>
            <div class="card-header-actions">
              <div class="card-header-action" style="display: inline-block; cursor: pointer;">
                <b-link class="card-header-action">
                  <i @click="exportRouteInXlsx" class="cui-cloud-download"/>
                  <a @click="exportRouteInXlsx">&nbsp;Export Xlsx&nbsp;</a>
                </b-link>
                <v-date-picker
                  :popover-visibility="calendarFromVisibility"
                  :style="{display: 'inline-block'}"
                  popoverAlign="center"
                  @dayclick="dayFromClicked"
                  v-model="currentDateFrom"
                >
                  <template slot-scope="props">
                    <i @click="openCalendarFrom" class="icon-calendar"></i>
                  </template>
                </v-date-picker>
              </div>
              <b-link class="card-header-action">{{ routesDateFrom.toFormat('dd LLL yyyy') }}</b-link>
              <div class="card-header-action" style="display: inline-block; cursor: pointer;">
                <v-date-picker
                  :popover-visibility="calendarToVisibility"
                  :style="{display: 'inline-block'}"
                  popoverAlign="center"
                  @dayclick="dayToClicked"
                  v-model="currentDateTo"
                >
                  <template slot-scope="props">
                    <i @click="openCalendarTo" class="icon-calendar"></i>
                  </template>
                </v-date-picker>
              </div>
              <b-link class="card-header-action">{{ routesDateTo.toFormat('dd LLL yyyy') }}</b-link>
            </div>
          </div>
          <div v-if="loading" class="sk-wave">
            <div class="sk-rect sk-rect1"></div>&nbsp;
            <div class="sk-rect sk-rect2"></div>&nbsp;
            <div class="sk-rect sk-rect3"></div>&nbsp;
            <div class="sk-rect sk-rect4"></div>&nbsp;
            <div class="sk-rect sk-rect5"></div>&nbsp;
          </div>

          <b-table
            v-else
            hover
            striped
            bordered
            small
            stacked="sm"
            :items="routesWithTotals"
            :fields="fields"
          >
            <template slot="position" slot-scope="data">
              <span :class="[data.item._isTotalRow ? 'bold' : '']">{{ data.item.position }}</span>
            </template>
            <template slot="startedAt" slot-scope="data">
              <span
                :class="[data.item._isTotalRow ? 'bold' : '']"
              >{{ data.item.startedAt | formatDate }}</span>
            </template>
            <template slot="stoppedAt" slot-scope="data">
              <span
                :class="[data.item._isTotalRow ? 'bold' : '']"
              >{{ data.item.stoppedAt | formatDate }}</span>
            </template>
            <template slot="duration" slot-scope="data">
              <span :class="[data.item._isTotalRow ? 'bold' : '']">{{ toTime(data.item.duration) }}</span>
            </template>
            <template slot="distance" slot-scope="data">
              <span
                :class="[data.item._isTotalRow ? 'bold' : '']"
              >{{ (data.item.distance / 1000.0).toFixed(2) }} Km</span>
            </template>

            <template slot="latitudeStart" slot-scope="data">
              <span :class="[data.item._isTotalRow ? 'bold' : '']">
                <AddressGeocoder
                  :latitude="data.item.latitudeStart"
                  :longitude="data.item.longitudeStart"
                />
              </span>
            </template>
            <template slot="latitudeStop" slot-scope="data">
              <span :class="[data.item._isTotalRow ? 'bold' : '']">
                <AddressGeocoder
                  :latitude="data.item.latitudeStop"
                  :longitude="data.item.longitudeStop"
                />
              </span>
            </template>
            <template slot="velocitaMedia" slot-scope="data">
              <span
                :class="[data.item._isTotalRow ? 'bold' : '']"
              >{{ data.item.velocitamedia }} Km/h</span>
            </template>
            <template slot="velocitaMassima" slot-scope="data">
              <span
                :class="[data.item._isTotalRow ? 'bold' : '']"
              >{{ data.item.velocitamassima }} Km/h</span>
            </template>
            <template slot="actions" slot-scope="data">
              <b-button
                v-if="!data.item._isTotalRow"
                @click="detailsClick(data.item.id)"
                variant="ghost-primary"
              >
                <i class="fa fa-map-o"></i>&nbsp;mappa
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddressGeocoder from "@/components/AddressGeocoder.vue";
import { DateTime } from "luxon";
import { setupCalendar, DatePicker } from "v-calendar";
import "v-calendar/lib/v-calendar.min.css";
import {
  SET_ROUTES_DATE_FROM,
  SET_ROUTES_DATE_TO
} from "@/store/mutation-types";

setupCalendar({
  firstDayOfWeek: 2, // Monday
  locale: "it"
});

export default {
  name: "routes",
  components: {
    AddressGeocoder,
    "v-date-picker": DatePicker
  },
  data() {
    return {
      currentDateFrom: this.$store.getters.routesDateFrom.toJSDate(),
      currentDateTo: this.$store.getters.routesDateTo.toJSDate(),
      calendarFromVisibility: "hidden",
      calendarToVisibility: "hidden",
      loading: false,
      fields: [
        {
          key: "position",
          label: ""
        },
        {
          key: "startedAt",
          label: "Ora start",
          sortable: true
        },
        {
          key: "stoppedAt",
          label: "Ora stop",
          sortable: true
        },
        {
          key: "duration",
          label: "Durata"
        },
        {
          key: "distance",
          label: "Distanza",
          sortable: false
        },
        {
          key: "latitudeStart",
          label: "Start"
        },
        {
          key: "latitudeStop",
          label: "Stop"
        },
        {
          key: "velocitaMedia",
          label: "Velocità media"
        },
        {
          key: "velocitaMassima",
          label: "Velocità massima"
        },
        {
          key: "actions",
          label: "",
          class: "text-center"
        }
      ]
    };
  },
  methods: {
    dayFromClicked(day) {
      const newDateFrom = DateTime.fromJSDate(day.date);
      this.$store.commit(SET_ROUTES_DATE_FROM, newDateFrom.startOf("day"));
      this.calendarFromVisibility = "hidden";
      this.currentDateFrom = newDateFrom.toJSDate();
      this.loadRoutes();
    },
    dayToClicked(day) {
      const newDateTo = DateTime.fromJSDate(day.date);
      this.$store.commit(SET_ROUTES_DATE_TO, newDateTo.startOf("day"));
      this.calendarToVisibility = "hidden";
      this.currentDateTo = newDateTo.toJSDate();
      this.loadRoutes();
    },
    detailsClick(id) {
      this.loadRoutes();
    },
    exportRouteInXlsx() {
      this.loading = true;
      this.$store
        .dispatch("exportRouteInXlsx", {
          contractId: this.selectedContract.id,
          from: this.routesDateFrom,
          to: this.routesDateTo
        })
        .then(/*routes => console.log("routes loaded")*/)
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    openCalendarFrom() {
      this.calendarFromVisibility =
        this.calendarFromVisibility == "hidden" ? "visible" : "hidden";
      this.calendarToVisibility = "hidden";
    },
    openCalendarTo() {
      this.calendarToVisibility =
        this.calendarToVisibility == "hidden" ? "visible" : "hidden";
      this.calendarFromVisibility = "hidden";
    },
    detailsClick(id) {
      this.$router.push("/routes/" + id);
    },
    toTime(seconds) {
      if (!seconds) {
        return "";
      }
      const date = new Date(null);
      date.setSeconds(seconds); // specify value for SECONDS here
      return date.toISOString().substr(11, 8);
    },
    loadRoutes() {
      this.loading = true;
      this.$store
        .dispatch("routes", {
          contractId: this.selectedContract.id,
          from: this.routesDateFrom,
          to: this.routesDateTo
        })
        .then(routes => console.log("routes loaded"))
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    }
  },
  mounted() {
    if (this.selectedContract) {
      this.loadRoutes();
    }
  },
  computed: {
    ...mapGetters([
      "routes",
      "selectedContract",
      "routesDateFrom",
      "routesDateTo"
    ]),
    routesWithTotals() {
      if (this.routes.length === 0) {
        return [];
      }

      let totalKm = 0;
      let totalDuration = 0;
      let firstStartDateTime;
      let lastStopDateTime;
      let firstLatitudeStart;
      let firstLongitudeStart;
      let firstLatitudeStop;
      let firstLongitudeStop;
      let velocitaMedia = 0;
      let velocitaMassima = 0;

      this.routes.forEach((r, i) => {
        totalKm += r.distance;
        totalDuration += r.duration;
        velocitaMedia += r.velocitamedia;

        if(velocitaMassima < r.velocitamassima)
          velocitaMassima = r.velocitamassima;

        if (i === 0) {
          firstStartDateTime = r.startedAt;
          firstLatitudeStart = r.latitudeStart;
          firstLongitudeStart = r.longitudeStart;
        }
        if (i === this.routes.length - 1) {
          lastStopDateTime = r.stoppedAt;
          firstLatitudeStop = r.latitudeStop;
          firstLongitudeStop = r.longitudeStop;
        }
      });

      velocitaMedia = Math.round(velocitaMedia / this.routes.length * 100) / 100;

      return [
        ...this.routes.map((e, i) => ({ ...e, position: i + 1 })),
        {
          position: "Tot",
          distance: totalKm,
          latitudeStart: firstLatitudeStart,
          longitudeStart: firstLongitudeStart,
          latitudeStop: firstLatitudeStop,
          longitudeStop: firstLongitudeStop,
          startedAt: firstStartDateTime,
          stoppedAt: lastStopDateTime,
          duration: totalDuration,
          velocitamedia: velocitaMedia,
          velocitamassima: velocitaMassima,
          _rowVariant: "info",
          _isTotalRow: true
        }
      ];
    }
  },
  watch: {
    selectedContract(newSelectedContract, oldSelectedContract) {
      if (!newSelectedContract) {
        return;
      }
      if (
        !oldSelectedContract ||
        newSelectedContract.id != oldSelectedContract.id
      ) {
        this.loadRoutes();
      }
    },
    routes(newRoutes, oldRoutes) {
      console.log("newRoutes");
    }
  }
};
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />

<style>
.bold {
  font-weight: bold;
}
</style>
